import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MapPin, Maximize2, Play, SplitSquareVertical, Calculator } from 'lucide-react';
import RenewalMap from './RenewalMap';

export default function GeoHotspotsWidget({ onExpandMap }) {
  const navigate = useNavigate();
  
  const handleViewDetails = (contractId) => {
    navigate(`/contracts/${contractId}`);
  };

  const handleAdvancedMap = () => {
    navigate('/map');
  };

  return (
    <Card className="col-span-2 row-span-2" data-testid="geo-hotspots-widget">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            <MapPin className="w-5 h-5 text-[#09409C]" />
            Geographic Hotspots
          </CardTitle>
          <div className="flex items-center gap-2">
            {onExpandMap && (
              <Button 
                variant="outline" 
                size="sm"
                onClick={onExpandMap}
                className="h-7 text-xs"
              >
                <Maximize2 className="w-3 h-3 mr-1" />
                Full Map
              </Button>
            )}
            <Button 
              variant="default" 
              size="sm"
              onClick={handleAdvancedMap}
              className="h-7 text-xs bg-[#09409C] hover:bg-[#146CBB]"
            >
              <Play className="w-3 h-3 mr-1" />
              Advanced
            </Button>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Contract locations and renewal concentration
        </p>
        {/* Quick feature pills */}
        <div className="flex items-center gap-2 mt-2">
          <span className="text-[10px] px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full flex items-center gap-1">
            <Play className="w-3 h-3" /> Time Animation
          </span>
          <span className="text-[10px] px-2 py-0.5 bg-purple-50 text-purple-700 rounded-full flex items-center gap-1">
            <SplitSquareVertical className="w-3 h-3" /> Split View
          </span>
          <span className="text-[10px] px-2 py-0.5 bg-green-50 text-green-700 rounded-full flex items-center gap-1">
            <Calculator className="w-3 h-3" /> What-If
          </span>
        </div>
      </CardHeader>
      <CardContent className="pt-2">
        <RenewalMap 
          height="280px"
          showLegend={true}
          showStats={true}
          onViewDetails={handleViewDetails}
          interactive={true}
        />
      </CardContent>
    </Card>
  );
}
